var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-picker"},[_c('el-date-picker',{ref:"datepicker",attrs:{"type":"date","size":"mini","placeholder":_vm.placeholder,"clearable":false,"format":"dd/MM/yyyy","picker-options":_vm.pickerOptions},on:{"closed":_vm.save},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }